module.exports = __webpack_public_path__ + "img/gift_off.47b58a73.png";